// extracted by mini-css-extract-plugin
export default {"container":"container_container__wpCME","margin":"container_margin__YUZT7","margin2":"container_margin2__WyCo6","margin3":"container_margin3__JMwgv"};